import React from 'react';
import { Chip } from '../chip';
import { StarRating } from '../star-rating';
import { PropertyScore } from '../property-score';
import { PictureContainer, Header, PropertyNicknameEditContainer, PropertyNickname, Footer, PropertyScoreContainer, PropertyScoreValuesContainer, RatingContainer, EditButton, StyledPictogram, Container, ChipContainer, ButtonContainer, } from './PropertyHeader.styled';
export const PropertyHeader = ({ imageUrl = '', size, nickname, isNicknameEditable = false, onEditClick, chipStatus, showFooter = false, score, starRating, rating, numberOfReviews, localization = {
    propertyScore: 'Property score',
    propertyScoreOutOf: 'out of',
    propertyScoreFromReviews: 'from',
    propertyScoreReviews: 'reviews',
}, }) => {
    const hasFooter = showFooter && score && starRating;
    return (React.createElement(Container, null,
        React.createElement(PictureContainer, { url: imageUrl, size: size, hasFooter: true },
            !imageUrl && (React.createElement(StyledPictogram, { name: "propertyVilla", variant: "light", size: 80 })),
            React.createElement(Header, null,
                React.createElement(PropertyNicknameEditContainer, null,
                    React.createElement(PropertyNickname, null, nickname),
                    isNicknameEditable && (React.createElement(ButtonContainer, null,
                        React.createElement(EditButton, { "aria-label": "edit-property-nickname", icon: "Pencil", size: "small", variant: "white", fill: "clear", onClick: onEditClick })))),
                React.createElement(ChipContainer, null,
                    React.createElement(Chip, Object.assign({}, chipStatus))))),
        hasFooter && (React.createElement(Footer, { size: size },
            React.createElement(PropertyScoreContainer, null,
                React.createElement(PropertyScore, Object.assign({}, score)),
                React.createElement(PropertyScoreValuesContainer, null,
                    React.createElement("span", null,
                        React.createElement("b", null, localization.propertyScore)),
                    React.createElement("span", null,
                        React.createElement("b", null, score.score),
                        ' ',
                        localization.propertyScoreOutOf,
                        " ",
                        React.createElement("b", null, "100")))),
            React.createElement(RatingContainer, null,
                React.createElement(StarRating, Object.assign({}, starRating)),
                React.createElement("span", null,
                    React.createElement("b", null, rating),
                    ' ',
                    localization.propertyScoreFromReviews,
                    ' ',
                    React.createElement("b", null, numberOfReviews),
                    ' ',
                    localization.propertyScoreReviews))))));
};
//# sourceMappingURL=PropertyHeader.js.map